import type { ReactNode } from 'react'

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className="mb-6 flex flex-wrap items-start gap-4">
      <div>
        <h1 className="text-[25px] leading-tight">{title}</h1>
        {subtitle && (
          <div className="mt-1.5 flex flex-wrap items-center gap-2.5 text-[13.5px] text-muted-foreground">
            {subtitle}
          </div>
        )}
      </div>
      {actions && <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
